import { memo } from 'react';

import WaitingIconSVG from '@/assets/waiting-icon-filled.svg?react';
import { Icon, IconProps } from '@/components/core';

const IWaitingIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={WaitingIconSVG} {...props} />;

export const WaitingFilledIcon = memo(IWaitingIcon) as typeof IWaitingIcon;
